import * as z from 'zod';

// Hours and minutes of overtime (not a clock time): one payoff may exceed a day, e.g. "41:30".
export const PAYOFF_TIME_PATTERN = /^\d{1,4}:[0-5]\d$/;
// OVERTIME_PAYOFF takes at least one minute.
const MIN_PAYOFF_SECONDS = 60;

export const payoffSecondsOf = (payoffTime: string) => {
  const [hours, minutes] = payoffTime.split(':').map(Number);
  return hours * 3600 + minutes * 60;
};

export const createPayoffFormSchema = (remainingInSecond: number, isNoteRequired: boolean) =>
  z
    .object({
      PayoffTime: z.string().trim().regex(PAYOFF_TIME_PATTERN, { message: 'INVALID_TIME_FORMAT' }),
      Note: z.string().optional(),
    })
    .refine((data) => payoffSecondsOf(data.PayoffTime) >= MIN_PAYOFF_SECONDS, {
      message: 'PAYOFF_TIME_TOO_SHORT',
      path: ['PayoffTime'],
    })
    .refine((data) => payoffSecondsOf(data.PayoffTime) <= remainingInSecond, {
      message: 'PAYOFF_CANNOT_EXCEED_REMAINING_OVERTIME',
      path: ['PayoffTime'],
    })
    .refine((data) => !isNoteRequired || Boolean(data.Note?.trim()), {
      message: 'NOTE_REQUIRED',
      path: ['Note'],
    });

export type PayoffFormValues = z.infer<ReturnType<typeof createPayoffFormSchema>>;
